import dragscroll from './dragscroll'

const install = function (Vue) {
  Vue.directive('dragscroll', dragscroll)
}

if (window.Vue) {
  window.dragscroll = dragscroll
  Vue.use(install)
}

dragscroll.install = install
export default dragscroll
